<div class="d-flex justify-content-between align-items-center">
	<h5 class="d-flex align-items-center my-4 fw-bold">
		<i class="display-6 me-2 fa-solid fa-hourglass"></i> Zmiana cennika dla wybranych terminów
	</h5>
	<button mat-button class="h-100 py-1" [disabled]="disableHTMLClose" [mat-dialog-close]="false" cdkFocusInitial>
		<i class="fs-3 fas fa-times"></i>
	</button>
</div>
<app-group-offer-price-setting
	[currency]="currency"
	[board]="board"
	[priceSetting]="priceSetting"
	[(priceOption)]="priceOption"
	[(termData)]="data"
	(closeDialog)="closeDialog()"
></app-group-offer-price-setting>
